import Divider from '@mui/material/Divider';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CloseIcon from '@mui/icons-material/Close';
import { useState } from 'react';
import PropTypes from 'prop-types';

const HelpMenu = ({open, handleClose, anchorEl}) => {
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Menu open={open} 
      id='help-menu' 
      MenuListProps={{
        'aria-labelledby': 'help-button',
        'disablePadding': true
      }} 
      anchorEl={anchorEl} 
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
    >
      <MenuItem onClick={handleClose} sx={{display: 'flex', justifyContent: 'space-between', paddingY: '12px'}}>
        <Typography sx={{fontWeight: 700, fontSize: '16px !important', color: '#000 !important'}}>
          Help
        </Typography>
        <CloseIcon/>
      </MenuItem>

      <Divider sx={{margin: '0 !important'}}/>

      <Accordion disableGutters sx={{width: 320 }} expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography sx={{fontWeight: 700, color:'#000 !important'}}>Call Store</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography sx={{color:'#000 !important', fontSize:'14px !important', fontWeight: 700}}>
            From Customer FIRST:
          </Typography>
            <ol className='help-menu-list'>
              <li>Verify the customer's mobile number.</li>
              <li>Create the Work Order and select <b>'Drop-Off'</b> as the customer status.</li>
            </ol>
          <Typography sx={{color:'#000 !important', fontSize:'14px !important', fontWeight: 700}}>
            From Message Runner when a call is needed:
          </Typography>
            <ol className='help-menu-list'>
              <li>Find the customer you want to text and click <b>'Call Store'</b> button.</li>
              <li>Enter your name and store's phone number.</li>
              <li>Click <b>'Send'</b>.</li>
            </ol>
          <Typography sx={{color:'#000 !important', fontSize:'14px !important'}}>
            Confirm whether or not you want to text and click <b>'Yes'</b>.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion disableGutters sx={{width: 320}} expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
        >
          <Typography sx={{fontWeight: 700, color:'#000 !important'}}>BeBack+</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography sx={{color:'#000 !important', fontSize:'14px !important', fontWeight: 700}}>
            From Customer FIRST:
          </Typography>
          <ol className='help-menu-list'>
            <li>Verify the customer's mobile number.</li>
            <li>Create the Work Order and select <b>'BeBack+'</b> as the vehicle location.</li>
          </ol>
          <Typography sx={{color:'#000 !important', fontSize:'14px !important', fontWeight: 700}}>
            From Message Runner when 20 minutes out:
          </Typography>
          <ol className='help-menu-list'>
            <li>Find the customer you want to text and click the <b>'BeBack+'</b> button.</li>
          </ol>
          <Typography sx={{color:'#000 !important', fontSize:'14px !important', fontWeight: 700}}>
            Click 'Yes' to send the text to the customer.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion disableGutters sx={{width: 320}} expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3a-content"
          id="panel3a-header"
        >
          <Typography sx={{fontWeight: 700, color:'#000 !important'}}>Vehicle Ready</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography sx={{color:'#000 !important', fontSize:'14px !important', fontWeight: 700}}>
            From Customer FIRST:
          </Typography>
          <ol className='help-menu-list'>
            <li>Verify the customer's mobile number.</li>
            <li>Create the Work Order and select <b>'Drop-Off'</b> as the customer status.</li>
          </ol>
          <Typography sx={{color:'#000 !important', fontSize:'14px !important', fontWeight: 700}}>
            From Message Runner when ready for pickup:
          </Typography>
          <ol className='help-menu-list'>
            <li>Find the customer you want to text and click <b>'Vehicle Ready'</b>.</li>
            <li>Confirm whether or not you want to send the text by clicking <b>'Yes'</b>.</li>
          </ol>
        </AccordionDetails>
      </Accordion>
    </Menu>
  );
}

HelpMenu.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  anchorEl: PropTypes.object,
};

export default HelpMenu;